/* istanbul ignore file */
export default {
  dateFrom: {
    type: 'date',
    required: true,
    maxDate: {
      value: '$NOW',
      message: 'Access log cannot be in future',
    },
  },
  dateTo: {
    type: 'date',
    required: true,
    minDate: {
      value: '$dateFrom',
      message: 'Please choose date after or at start date',
    },
    maxDate: {
      value: '$NOW',
      message: 'Access log cannot be in future',
    },
  },
};
